import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {getSubscriptionsToRenewV3} from '../services/guest.http'

export const useGetSubscriptionsToRenewV3 = (enabled: boolean | undefined = true) => {
    return useQuery({
        queryKey: [QUERY_KEYS.subscriptionsToRenewV3],
        queryFn: getSubscriptionsToRenewV3,
        enabled
    })
}
